'use strict';

var util = require('../../util'),
    shipping = require('./shipping'),
    dynamicAddress = require('../dynamic-address'),
    addressUtil = require('../../helpers/address.utils');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('.address'),
        $addressList = $('input[name$="_addressList"]');
    // select address from list
    $($addressList, $form).on('change', function () {
    	
    	if($('input[name$="_saveBillingAddress"]').val() == "1") {
        	$('input[name$="_addressList"]').prop('checked', false);
        } 
    	
        var selected = $('input[name$="_addressList"]:checked');
        var selectedAddress = $(selected).data('address');

        if (!selectedAddress) { return; }

        selectedAddress['phone--dummy'] = selectedAddress.phone;

        //If the dynamic fields container is present, run fillAddressFields after new format is in place.
        if(document.querySelector('.order--checkout__dynamic-fields')) {
            dynamicAddress.getAddressFields(selectedAddress.countryCode, '.order--checkout__dynamic-fields', window.Urls.getBillingAddressForm, util.fillAddressFields.bind(this, selectedAddress, $form));
        }

        else {
            util.fillAddressFields(selectedAddress, $form);
            addressUtil.updateFields()
        }

        shipping.updateShippingMethodList();
        // re-validate the form
        // var validator = $form.validate({
        //     ignore: '[name*="paymentMethods"]'
        // });

        // $form.validate().form();
    });
    $(function() {
	    if($('input[name$="_saveBillingAddress"]').val() == "1") {
	    	$('input[name$="_addressList"]').prop('checked', false);
	    } else {
	        var unsaveddAddress = $('[id$="_unsavedAddressBook"]').is(':checked');
	        if(!unsaveddAddress) {
	            $addressList.trigger('change');
	        }
	    }
    });
    
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/checkout/address.js